exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  /* Header + Toolbar heights 56px + 50px = 106px */\n  padding-top: 106px;\n  font-family: sans-serif;\n}\n\n.bootstrap-btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\n.bootstrap-btn-outline-dark:disabled {\n  background-color: lightgray !important;\n  opacity: 0.4 !important;\n  border-color: gray;\n}\n\n.bootstrap-btn:disabled {\n  cursor: not-allowed;\n}\n\ntable.dataTable.table-sm .sorting:before,\ntable.dataTable.table-sm .sorting_asc:before,\ntable.dataTable.table-sm .sorting_desc:before {\n  right: 19px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/index.css
// module id = 142
// module chunks = 0